import React from "react";

const Footer = () =>{
    return(
        <footer className="footer">
            <div className="footer-content">
                <div className="contact-info">
                    <p>Email: <a href="mailto:rjzambrano87@gmail.com">rjzambrano87@gmail.com</a></p>
                    
                    <p>Ubicación: Donostia - San Sebastian, España</p>
                </div>
                <div className="social-links">
                    <a href="https://github.com/Jackmanek?tab=repositories" target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-github"></i>
                    </a>
                    <a href="https://www.linkedin.com/in/jasmany-zambrano-redroban-2386a5219" target="_blank" rel="noopener noreferrer">
                        <i className="fa-brands fa-linkedin"></i>
                    </a>
                </div>
            </div>
            <div className="footer-bottom">
                <p>© 2024 Jasmany Zambrano. Todos los derechos reservados.</p>
            </div>
        </footer>
    );
}

export default Footer;
